import React from "react";
import Button from "../Buttons/Button";

const colorStyles = {
  type1: "bg-gradient-to-r from-[#135058CC] to-[#A8A896A3] text-white", // Adjust colors as needed
  type2: "bg-gradient-to-r from-[#003024CC] to-[#40BE9FA3] text-white",
  type3: "bg-gradient-to-r from-[#00223ECC] to-[#C6846CA3] text-white",
  type4: "bg-gradient-to-b from-gray-200 to-white text-black shadow",
};

const InfoCard = ({
  title = "Missing Timesheet",
  icon = "auto_stories",
  color = "type1", //type1,type2,type3,type4
  value = 0,
  prefix,
  suffix,
  action,
}) => {
  return (
    <div
      className={`px-4 py-4 flex flex-col gap-3 self-start w-full rounded-md ${colorStyles[color]} select-none`}
    >
      <div className="flex items-center gap-1  info-message">
        <span className={`material-symbols-rounded info-message text-[18px]`}>
          {icon}
        </span>
        {title}
      </div>
      <div className="flex justify-between items-center gap-3">
        <div className="subtitle-two flex gap-1">
          <span>{prefix}</span>
          <span>{value} </span>
          <span>{suffix}</span>
        </div>
        {action && (
          <Button
            type="icon"
            variant="text"
            color="white"
            icon={"east"}
            onClick={action}
          />
        )}
      </div>
    </div>
  );
};

export default InfoCard;
